import axios from 'axios';
import { FETCH_AWARD } from './types';
import api from '../../../utils/api';

export default {
  async fetchAwards(_, page) {
    const { data } = await axios(api.awards.fetchAwards(page));
    return data;
  },
  async fetchAward({ commit }, awardId) {
    const { data } = await axios(api.awards.fetchAward(awardId));
    commit(FETCH_AWARD, { award: data });
    return data;
  },
  async fetchJuries(_, awardId) {
    const { data } = await axios(api.awards.fetchJuries(awardId));
    return data.results;
  },
  async fetchCategories(_, awardId) {
    const { data } = await axios(api.awards.fetchCategories(awardId));
    return data.results;
  },
  async fetchAgenda(_, awardId) {
    const { data } = await axios(api.awards.fetchAgenda(awardId));
    return data.results;
  },
  async fetchAgendaMaps(_, awardId) {
    const { data } = await axios(api.awards.fetchAgendaMaps(awardId));
    return data.results;
  },
  async fetchGallery(_, awardId) {
    const { data } = await axios(api.awards.fetchGallery(awardId));
    return data.results;
  },
  async fetchAwardCategories(_, awardId) {
    const { data } = await axios(api.awards.fetchAwardCategories(awardId));
    return data.results;
  },
  async fetchAwardSponsors(_, categoryId) {
    const { data } = await axios(api.awards.fetchAwardSponsors(categoryId));
    return data.results;
  },
  async fetchShortlisted(_, categoryId) {
    const { data } = await axios(api.awards.fetchShortlisted(categoryId));
    return data.results;
  },
  async fetchRegistrationList(_, awardId) {
    const { data } = await axios(api.awards.fetchRegistrationList(awardId));
    return data.results;
  },
  async awardBooking({}, bookingDetails) {
    const { data } = await axios(api.awards.awardBooking(bookingDetails));
    return data;
  },
  async fetchBookedAwards({}, customerId) {
    const { data } = await axios(api.awards.fetchBookedAwards(customerId));
    return data.results;
  },

  async applyForCategory(_, application) {
    const { data } = await axios(api.awards.applyForCategory(application));
    return data;
  },
  async editApplication(_, application) {
    const { data } = await axios(api.awards.editApplication(application));
    return data;
  },
  async deleteApplication(_, id) {
    await axios(api.awards.deleteApplication(id));
  },
  async applyDocumentForCategory(_, data) {
    await axios(api.awards.applyDocumentForCategory(data));
  },
  async editApplicationDocument(_, application) {
    const { data } = await axios(api.awards.editApplicationDocument(application));
    return data;
  },
  async deleteApplicationDocument(_, id) {
    await axios(api.awards.deleteApplicationDocument(id));
  },
  async fetchMyCompanyApplications(_, awardId) {
    const { data } = await axios(api.awards.fetchMyCompanyApplications(awardId));
    return data;
  },
  async sendEmailToApplicant(_, emailData) {
    const { data } = await axios(api.awards.sendEmailToApplicant(emailData));
    return data;
  },
  async fetchAwardQuestions(_, { awardId, customerId }) {
    const { data } = await axios(api.awards.fetchAwardQuestions(awardId, customerId));
    return data;
  },
  async submitQuestionsAnswers(_, { awardId, customerId, answers }) {
    const { data } = await axios(api.awards.submitQuestionsAnswers(awardId, customerId, answers));
    return data;
  },
  async fetchSubmission(_, submissionId) {
    const { data } = await axios(api.awards.fetchSubmission(submissionId));
    return data;
  },
  async fetchGCCWinners(_, awardId) {
    const { data } = await axios(api.awards.fetchGCCWinners(awardId));
    return data.results;
  }
};
